// Global sidebar collapse state. Module-level singleton + localStorage so it
// persists across reloads and is shared by the Sidebar and the TopBar toggle.
import { ref } from 'vue';

const KEY = 'lymon-sidebar-collapsed';

function initial(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

const collapsed = ref<boolean>(initial());
// Mobile drawer open/closed — transient (not persisted): below `lg` the sidebar
// is an off-canvas overlay opened from the TopBar hamburger.
const mobileOpen = ref<boolean>(false);

export function useSidebar() {
  function setCollapsed(v: boolean): void {
    collapsed.value = v;
    try {
      localStorage.setItem(KEY, v ? '1' : '0');
    } catch {
      /* storage disabled — non-fatal */
    }
  }
  function toggle(): void {
    setCollapsed(!collapsed.value);
  }
  function toggleMobile(): void { mobileOpen.value = !mobileOpen.value; }
  function closeMobile(): void { mobileOpen.value = false; }
  return { collapsed, toggle, setCollapsed, mobileOpen, toggleMobile, closeMobile };
}
